import React, { Component } from "react";
// Styles
import "./GameComplete.scss";

// Components
// import First from "static/img/first-star.svg";
// import Second from "static/img/middle-star.svg";
// import Third from "static/img/last-star.svg";
// import FlashAstonaut from "static/img/astonaut-flash.svg";
// import AstronautImage from "static/img/astronautimage.svg";
import { sendData } from "services/ApiService";
import Hurray from "static/img/hurray.svg";
import { GC } from '../../services/config/gamecentreService';
import { storage } from '../../services/config/storage';
import { BackgroundMusicStop } from "utility/sounds";

class GameComplete extends Component {
  constructor(props) {
    super(props);
    if (!props.location.stats) this.props.history.replace("/level");
  }

  async componentDidMount() {
    BackgroundMusicStop()
    if (!this.props.location.stats) this.props.history.replace("/level");
    else if (this.props.location.stats.api) {
      let { stats } = this.props.location;
      await sendData({
        ...stats,
        seconds: stats.seconds,
        completed: stats.completed
      });
    }
  }

  nextGame() {
    GC.sendGameEndMessage()
    storage.destroy.all();
  }

  render() {
    let { stats } = this.props.location;
    let seconds = 0;
    if (stats && stats.time)
      seconds = stats.time
        .map(entry => entry.start - entry.end)
        .reduce((prev, current) => prev + current, 0);
    return (
      <>
        <div className="level-layout level-layout2 game-complete-level">
          <div className="game-complete">
            <div className="completion-tab">
              <div className="completeLevel">
                <img className="hurray-img" src={Hurray} alt="hurray" />
              </div>
              <div className="game-section">
                <p className="great">You did great!</p>
                <div className="accuracy-wrapper">
                  <div className="accuracy-tab">
                    <p className="leveltext">
                      Levels completed
                      <span className="result">
                        {stats && stats.currentLevel && stats.currentLevel < stats.total
                          ? stats.currentLevel - 1
                          : stats.currentLevel}
                      </span>
                    </p>
                    <p className="leveltext">
                      Time{" "}
                      <span className="result">
                        {`${Math.floor(seconds / 60).toLocaleString("en-US", {
                          minimumIntegerDigits: 2
                        })}:${Math.floor(seconds % 60).toLocaleString("en-US", {
                          minimumIntegerDigits: 2
                        })}`}{" "}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="btn-wrapper">
                  <button
                    className="tab-for-next"
                    onClick={() => this.nextGame()}
                  >
                    <span className="btn-text">Continue</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default GameComplete;
